module.exports = {
  ARROW_SIZE: 40,
};
